import { useMemo } from "react";

import { CommandGroup } from "~/core/ui/Command";

import { useGlobalCommandbarStore } from "../../store";
import { CommandbarFilterTabType } from "../../types/common";

import CommandbarItem from "./CommandbarItem";

export default function RecordsSection() {
  const commandbarSearchItems = useGlobalCommandbarStore(
    st => st.commandbarSearchItems,
  );
  const searchQuery = useGlobalCommandbarStore(st => st.searchQuery);
  const activeFilterTab = useGlobalCommandbarStore(st => st.activeFilterTab);

  const groupHeading = useMemo(() => {
    const isEmptySearchQuery = searchQuery?.trim().length === 0;
    const isAllTab = activeFilterTab === CommandbarFilterTabType.ALL;
    return isEmptySearchQuery && isAllTab ? "Recent records" : "Records";
  }, [activeFilterTab, searchQuery]);

  if (commandbarSearchItems.length === 0) return null;

  return (
    <CommandGroup
      heading={groupHeading}
      className="[&_[cmdk-group-heading]]:pt-0 [&_[cmdk-group-heading]]:font-normal"
    >
      {commandbarSearchItems.map(command => (
        <CommandbarItem key={command.id} command={command} />
      ))}
    </CommandGroup>
  );
}
